module.exports = __webpack_public_path__ + "static/assets/b99570035df9906d08eef06cc55f60fd.svg";